import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { BillingAdminComponent } from '@clubhub/ignite/components/billing-admin/billing-admin.component';
import { SaveBillingOrgModalComponent } from '@shared/components/save-billing-org-modal/save-billing-org-modal.component';
import { ModalService } from '../modal.service';

export const unsavedBillingOrgGuard: CanDeactivateFn<BillingAdminComponent> = async (component) => {
  const modalService = inject(ModalService);

  if (component.hasUserChanges) {
    try {
      const res: boolean | undefined = await modalService
        .open({
          component: SaveBillingOrgModalComponent,
          size: 'md',
          windowClass: 'billing-admin-unsaved-changes-modal',
          data: {
            leavingPage: true,
          },
        });

      if (res) {
        await component.save();
      } else {
        component.hasUserChanges = false;
      }

      return true;

    } catch {
      return false;
    }
  }

  component.hasUserChanges = false;
  return true;
};
